import {
  FileSearch,
  Construction,
  BadgeCheck,
  Building2,
  Users,
  Landmark,
  ShieldCheck,
} from "lucide-react";

export const features = [
  {
    title_en: "For Developers",
    title_ar: "للمطورين العقاريين",
    description_en:
      "Streamline project lifecycles from blueprints to financing through integrated digital management.",
    description_ar:
      "إدارة دورة حياة المشاريع من المخططات إلى التمويل عبر منظومة رقمية متكاملة.",
    icon: Building2,
  },
  {
    title_en: "For Brokers",
    title_ar: "للمسوقين والوكلاء",
    description_en:
      "Access verified inventory and connect directly with institutional financing for faster closures.",
    description_ar:
      "الوصول إلى مخزون عقاري موثق والربط المباشر مع التمويل المؤسسي لإتمام الصفقات بسرعة.",
    icon: Users,
  },
  {
    title_en: "For Banks",
    title_ar: "للمؤسسات البنكية",
    description_en:
      "Digital asset liquidation and mortgage processing with full transparency and SAMA compliance.",
    description_ar:
      "تصفية الأصول العقارية ومعالجة القروض السكنية بشفافية كاملة وتوافق مع أنظمة ساما.",
    icon: Landmark,
  },
  {
    title_en: "Secure Ecosystem",
    title_ar: "منظومة آمنة",
    description_en:
      "Unified platform connecting all parties under high-security standards and regulatory oversight.",
    description_ar:
      "منصة موحدة تربط جميع الأطراف تحت معايير أمنية عالية ورقابة تنظيمية دقيقة.",
    icon: ShieldCheck,
  },
];

export const developerSteps = [
  {
    id: "01",
    title_en: "Registration & Verification",
    title_ar: "التسجيل والتحقق",
    description_en:
      "Secure onboarding for developers and banks with rigorous credential verification.",
    description_ar:
      "انضمام آمن للمطورين والبنوك مع تحقق دقيق من الوثائق والاعتمادات.",
    icon: FileSearch,
  },
  {
    id: "02",
    title_en: "Asset Integration",
    title_ar: "إدراج الأصول",
    description_en:
      "Digital mapping and project uploading with direct banking liquidity assessment.",
    description_ar:
      "ربط رقمي ورفع المشاريع مع تقييم مباشر للسيولة البنكية المتاحة.",
    icon: Construction,
  },
  {
    id: "03",
    title_en: "Financing & Auctions",
    title_ar: "التمويل والمزادات",
    description_en:
      "Automated mortgage processing and institutional asset liquidation auctions.",
    description_ar:
      "معالجة آلية للتمويل العقاري ومزادات تصفية الأصول للمؤسسات.",
    icon: Landmark,
  },
  {
    id: "04",
    title_en: "Verified Settlement",
    title_ar: "التسوية المعتمدة",
    description_en:
      "Instant legal transfer and financial settlement backed by KSA banking standards.",
    description_ar:
      "نقل ملكية فوري وتسوية مالية مدعومة بمعايير القطاع البنكي السعودي.",
    icon: BadgeCheck,
  },
];

// TERMS
export const termsData = {
  ar: [
    {
      title: "أولاً: الشروط والأحكام العامة للتطبيق",
      content: [
        "1. المقدمة والقبول",
        "1.1 يُتيح موقع SNA العقارية (المشار إليه فيما بعد بـ”التطبيق” أو“المنصّة”) خدمة عرض، بيع، شراء وتأجير العقارات داخل المملكة العربية السعودية.",
        "1.2 باستخدامك التطبيق، تكون قد قرأت هذه الشروط والأحكام ووافقت على الالتزام بها. وبمجرد استخدام التطبيق يكون المستخدم موافق على جميع هذه الأحكام والشروط.",
        "2. التعاريف",
        "• المنصة/التطبيق: نظام SNA الإلكتروني (المنصة أو الموقع الإلكتروني أو تطبيق جوال أو واجهات برمجية).",
        "• المستخدم: أي شخص طبيعي أو اعتباري يقوم بإنشاء حساب أو يستخدم المنصّة لأي غرض من الأغراض النظامية المشروعة (كمشتري، مستأجر، وكيل، مطور، بنك، أو جهة تمويلية).",
        "• الوكيل: وسيط عقاري مرخّص نظاميا يقدم خدمات عبر المنصة.",
        "• المطوّر: أي شركة أو جهة تمتلك مشاريع عقارية مطروحة للبيع أو التأجير، وتعرضها من خلال التطبيق.",
        "• البنك/الجهة التمويلية: جهة تعرض منتجات تمويلية عبر المنصة.",
        "• الهيئة: الهيئة العامة للعقار وأي جهات حكومية أخرى ذات علاقة بتنظيم القطاع العقاري داخل المملكة.",
        "3. نطاق الخدمة",
        "3.1 المنصة تعمل كوسيط تقني مرخص لعرض العقارات وربط الأطراف؛ ولا تُعدّ بأي حالٍ من الأحوال بديلًا عن الإجراءات القانونية الرسمية المتعلقة بنقل الملكية أو إبرام عقود الإيجار.",
        "3.2 توفر المنصّة للمستخدمين أدوات وخدمات تقنية تشمل إدارة الإعلانات العقارية، والتواصل بين الأطراف، وجدولة الزيارات، وإنشاء ملفات خاصة بالعقارات، إضافةً إلى إمكانية الربط مع حلول التمويل العقاري المعتمدة.",
        "4. الالتزام بالأنظمة والحوكمة",
        "4.1 تلتزم المنصة وتطلب من جميع الأطراف الالتزام بكافة الأنظمة واللوائح السعودية ذات العلاقة بالنشاط العقاري بما في ذلك متطلبات الرخص وحماية البيانات والضريبة والفوترة الإلكترونية، وتنظيم خدمات الدفع الالكتروني.",
        "5. إنشاء الحساب والتحقّق",
        "5.1 عند التسجيل في المنصّة، يلتزم المستخدم بتزويد بيانات صحيحة، دقيقة، ومحدثة بصفة مستمرة، ويتحمّل كامل المسؤولية عن أي بيانات غير صحيحة أو مضللة.",
        "5.2 يحق للمنصّة طلب أي وثائق أو مستندات تحقق لازمة مثل الهوية الوطنية أو الإقامة، والترخيص المهني للوكيل أو المطوّر العقاري، وسندات الملكية، والتفويضات الرسمية، ويحق لها إيقاف الحساب مؤقتًا أو نهائيًا.",
        "6. الملكية الفكرية",
        "6.1 جميع محتويات التطبيق بما في ذلك الشعارات، النصوص، الصور، تصاميم الواجهات، الأكواد البرمجية، والبيانات، تُعد ملكية فكرية حصرية لشركة مسار الامجاد.",
        "7. الأسعار والدفعات والفوترة",
        "7.1 تعرض المنصة الأسعار التقديرية على أساس بيانات فنية، وتُطبَق ضريبة القيمة المضافة حيثما ينطبق، والفوترة الإلكترونية طبقاً لمتطلبات هيئة الزكاة والضريبة والجمارك.",
        "8. حماية البيانات والخصوصية",
        "8.1 تجمع المنصة بيانات شخصية وبيانات مواقع بغرض تقديم الخدمة وتحسينها، وتلتزم بحماية البيانات وتطبيق متطلبات حفظ وسرية البيانات.",
        "9. حدود المسؤولية",
        "9.1 المنصة وسيط تقني؛ لا تتحمل مسؤولية صحة أو اكتمال أو ملكية أي عقار أو أي اتفاق يتم خارج إطار التعاقد القانوني بين الأطراف.",
        "9.2 لا تَتحمّل المنصة خسائر غير مباشرة أو تبعية تنشأ عن استخدام المنصة.",
        "10. إنهاء الحساب والتعليق",
        "10.1 للمنصة الحق في تعليق، إيقاف، أو حذف أي حساب أو إعلان عند خرق هذه الشروط أو بناء على طلب جهة رسمية أو لأسباب أمنية.",
        "11. تسوية النزاعات والقانون الواجب التطبيق",
        "11.1 تخضع هذه الشروط لأنظمة المملكة العربية السعودية، والاختصاص القضائي للمحاكم السعودية.",
        "11.2 تعد اللغة العربية هي المرجع في حال وجود أي تعارض أو اختلاف بين النصوص.",
      ],
    },
    {
      title: "ثانياً: شروط وأحكام الوكلاء والوسطاء العقاريين",
      content: [
        "هذا القسم مخصّص للوكلاء المرخّصين الذين يستخدمون المنصة لعرض عقاراتهم والتواصل مع المشترين والمستأجرين.",
        "1. الأهلية والتسجيل",
        "1.1 يجب أن يكون الوكيل مسجلاً ومرخّصًا لدى الجهات المختصة، وأن يقدم نسخة من الترخيص والسجل التجاري وبيانات التواصل.",
        "1.2 تجرى عمليات تحقق للتأكد من صحة الوثائق ويُعلَن عن حالة الحساب لاحقًا.",
        "2. متطلبات إدراج العقار",
        "2.1 يجب تقديم معلومات دقيقة: وصف، عنوان، صور، مساحة، رقم الصك، حالة الملكية، والسعر.",
        "2.2 إن لم يكن الوكيل يمتلك الصك، يجب تقديم تفويض موثق.",
        "2.3 يُمنع نشر بيانات مضللة أو إخفاء عيوب.",
        "3. التوثيق ورسوم الثقة",
        "3.1 يتم وضع وسم 'موثق' بعد التحقق من الوثائق.",
        "3.2 الإعلانات غير الموثقة تُعرض عليها ملصق 'قيد التحقق'.",
        "4. التواصل والصفقات",
        "4.1 التواصل يتم ضمن قنوات المنصة.",
        "4.2 الاتفاق المالي النهائي يجب توثيقه بعقد قانوني، والمنصة ليست طرفاً.",
        "5. العمولات والرسوم",
        "5.1 دفع أي رسوم نشر مميزة أو خدمات تسويقية وفق خطة الأسعار.",
        "5.2 توضيح ترتيبات العمولة بين الوكيل والمالك.",
        "6. الإعلانات الممنوعة",
        "6.1 يمنع إدراج عقارات مخالفة للأنظمة.",
        "7. الضمانات والتعويض",
        "7.1 يتحمل الوكيل مسؤولية أي بيانات غير صحيحة ويلتزم بتعويض المنصة.",
        "8. الإيقاف والعقوبات",
        "8.1 للمنصة الحق في تعليق الإعلان أو الحساب عند المخالفة.",
        "9. متطلبات إضافية للمعلنين المحترفين",
        "9.1 قد تُطبق متطلبات إضافية للوسطاء الذين ينشرون عدد كبير من الإعلانات.",
      ],
    },
    {
      title: "ثالثاً: شروط وأحكام المطوّرين العقاريين",
      content: [
        "هذا القسم مخصّص للمطورين الذين يعرضون مشاريع سكنية/تجارية على المنصة، بما في ذلك المشاريع تحت الإنشاء.",
        "1. الأهلية والتسجيل",
        "1.1 تقديم سجل تجاري ساري، رخصة نشاط، ووثائق المشروع، مع بيانات ممثل مفوّض.",
        "1.2 التحقق من صحة المستندات قبل تفعيل صفحة المشروع.",
        "2. متطلبات عرض المشروع",
        "2.1 ملف المشروع الكامل: الأسعار، جدول الدفع، مواصفات الوحدات، صور/نماذج ثلاثية الأبعاد.",
        "2.2 الإفصاح عن مخاطر البيع المسبق والشروط المتعلقة به.",
        "3. الضمانات والتسليم",
        "3.1 تحديد تاريخ تسليم متوقع، مع تضمين بنود القوة القاهرة.",
        "3.2 توضيح سياسة الكفالات والصيانة بعد الاستلام.",
        "4. الحسابات المالية والدفعات",
        "4.1 قبول طرق دفع آمنة وإصدار فواتير إلكترونية.",
        "5. الإفصاحات القانونية",
        "5.1 الإفصاح عن أي قضايا أو قيود عقارية.",
        "5.2 الإفصاح عن أي تعديل جوهري في المشروع.",
        "6. الشراكة مع المنصة",
        "6.1 توقيع اتفاقية تحدد التزامات المنصة ونسبة العمولات.",
        "7. الإيقاف والمساءلة",
        "7.1 تعليق المشروع مؤقتًا أو نهائيًا عند ثبوت أي مخالفات.",
      ],
    },
    {
      title: "رابعاً: شروط وأحكام البنوك/التمويل العقاري",
      content: [
        "1. الشراكة والتسجيل",
        "1.1 توقيع اتفاقية شراكة قبل عرض المنتجات.",
        "1.2 تقديم ترخيص مصرفي ساري وتفاصيل التواصل.",
        "2. مشاركة البيانات وخصوصية العملاء",
        "2.1 مشاركة البيانات مع موافقة صريحة من المستخدم.",
        "2.2 البنك مسؤول عن سرية البيانات واستخدامها لغرض التمويل فقط.",
        "3. العروض والالتزام بالمعلومة",
        "3.1 توضيح شروط التمويل: سعر الفائدة، المدة، الرسوم، الضمانات.",
        "3.2 عدم الإعلان عن شروط مضللة.",
        "4. التحقق والاعتماد المبدئي",
        "4.1 تقديم خدمة اعتماد مبدئي مشروطة بالتحقق النهائي.",
        "4.2 المنصة غير مسؤولة عن قرار الائتمان النهائي.",
        "5. رسوم الإحالة/نموذج الربح",
        "5.1 يمكن الاتفاق على نسبة عمولة أو مبلغ ثابت لكل تحويل.",
        "5.2 الالتزامات الضريبية تقع على الطرفين وفق التشريعات.",
        "6. متطلبات الامتثال",
        "6.1 الالتزام بالمعايير والعمليات الائتمانية.",
        "6.2 للمنصة الحق في تعليق نقل البيانات عند شكوك احتيالية.",
        "7. واجهة التطبيق والربط التقني",
        "7.1 شروط الاستخدام التقني تحدد حدود الاستخدام، سياسة الأمان، مفاتيح API، الدعم الفني.",
        "7.2 أي تغيير يجب إخطار قبل خمسة عشر يوم.",
        "8. الإعلانات الترويجية والعروض",
        "8.1 توضيح شروط الرسوم ومدة العروض بشكل واضح.",
        "9. المسؤولية والضمانات",
        "9.1 المنصة غير مسؤولة عن قرارات البنك، والبنك مسؤول عن دقة المنتج.",
      ],
    },
    {
      title: "خامساً: شروط وأحكام الإعلان عن المزادات",
      content: [
        "1. تتيح المنصة الإعلان عن المزادات العقارية التي تنظمها الجهات المالكة أو المطورين أو الوسطاء أو البنوك.",
        "2. دور المنصة يقتصر على نشر الإعلان والتسويق بناءً على المعلومات المقدمة.",
        "3. الجهة المنظمة مسؤولة عن دقة التفاصيل وإتمام الإجراءات القانونية.",
        "4. المنصة غير مسؤولة عن نتائج المزاد أو النزاعات الناتجة عنه.",
        "5. الالتزام بالشروط التي تحددها الجهة المنظمة.",
        "6. المنصة تحتفظ بحق رفض أو إلغاء أي إعلان مخالف.",
        "7. رسوم الإعلان ثابتة وغير قابلة للاسترداد.",
        "8. باقات إضافية للإعلان المميز مقابل رسوم إضافية.",
        "9. الشكاوى توجه مباشرة للجهة المنظمة.",
      ],
    },
    {
      title: "سادساً: شروط وأحكام خدمة العرض ثلاثي الأبعاد",
      content: [
        "1. طبيعة الخدمة: أداة تقنية لمشاهدة العقارات بشكل افتراضي.",
        "2. مسؤولية المنصة: غير مسؤولة عن فروقات بين النموذج والمعاينة الفعلية.",
        "3. مسؤولية المالك/المطور: تقديم بيانات دقيقة وتحمل مسؤولية أي مغالطات.",
        "4. حقوق الملكية الفكرية: جميع النماذج محمية، لا يجوز نسخها بدون إذن.",
        "5. استخدام الخدمة: لأغراض التقييم المبدئي فقط، لا توجد التزامات قانونية.",
        "6. الامتثال للأنظمة: تلتزم المنصة بتحديث المعايير بما يتوافق مع الأنظمة السعودية.",
      ],
    },
    {
      title: "سابعاً: سياسة الخصوصية",
      content: [
        "1. المقدمة: حماية خصوصية المستخدمين والالتزام بالأنظمة.",
        "2. البيانات التي نجمعها: التسجيل، الاستخدام، العقار، التمويل، الموقع.",
        "3. كيفية استخدام البيانات: تحسين التجربة، التحقق من الهوية، مشاركة محدودة.",
        "4. مشاركة البيانات: بموافقة المستخدم، أو مع جهات حكومية أو شركاء المنصة.",
        "5. حماية البيانات: تشفير، مراكز بيانات داخل المملكة، وصول محدود للموظفين.",
        "6. حقوق المستخدم: الاطلاع، تصحيح، حذف البيانات، سحب الموافقة.",
        "7. الاحتفاظ بالبيانات: للفترة اللازمة لتقديم الخدمة أو وفق القانون.",
        "8. التعديلات: للمنصة الحق في تعديل السياسة مع إشعار المستخدمين.",
        "9. التواصل: عبر البريد الرسمي للاستفسارات.",
      ],
    },
    {
      title: "ثامناً: الرسوم والعمولات",
      main: [
        `تفرض منصة SNA العقارية ("المنصة") رسوماً وعمولات مقابل الخدمات المقدمة للمستخدمين ("المستفيد") وفقاً للفئات والبنود الموضحة أدناه. تُحتسب جميع المبالغ بالريال السعودي (ر.س) وتشمل ضريبة القيمة المضافة حيثما ينطبق ذلك، وفقاً للأنظمة المعمول بها في المملكة العربية السعودية.`,
      ],
      content: [
        "أولاً: أحكام عامة",
        "1. تخضع جميع الرسوم والعمولات للتحديث الدوري مع إشعار المستخدمين قبل 30 يوماً.",
        "2. يتم الدفع عبر بوابات الدفع الإلكترونية المعتمدة فقط.",
        "3. تطبق سياسة الاسترداد وفق البند (ثامناً).",
        "4. المنصة غير مسؤولة عن أي اتفاقات مالية خارج نطاقها.",

        "ثانياً: رسوم تسجيل الحسابات",
        "• تسجيل حساب أساسي مجاني لجميع الفئات.",
        "• خدمة التوثيق: الشهر الأول مجاني، الشهران الثاني والثالث 50 ريال لكل شهر، بعد ذلك 99 ريال شهرياً.",

        "ثالثاً: رسوم المشترين والبائعين والوكلاء",
        "• إدراج أول 3 عقارات مجاني، ثم 40 ريال لكل عقار إضافي.",
        "• تجديد الإعلان 30 ريال شهرياً بعد انتهاء 30 يوماً.",
        "• عضوية مميزة: 399 ريال شهرياً أو 3,999 ريال سنوياً.",
        "• الإعلانات المميزة: 7 أيام (80 ريال)، 15 يوم (140 ريال)، 30 يوم (240 ريال).",
        "• عمولة إتمام الصفقة 1% من قيمة الصفقة.",

        "رابعاً: رسوم المطورين العقاريين",
        "1. تسجيل مشروع جديد: 1,800 ريال.",
        "2. أول 20 وحدة مشمولة، ثم 15 ريال لكل وحدة إضافية.",
        "3. باقات التسويق: برونزية (4,000 ريال)، فضية (8,000 ريال)، ذهبية (15,000 ريال).",
        "4. عمولة المبيعات: 0.5% من قيمة الوحدة.",

        "خامساً: رسوم البنوك والجهات التمويلية",
        "1. رسوم التسجيل: 12,000 ريال.",
        "2. اشتراك سنوي: 22,000 ريال.",
        "3. عمولة نجاح التمويل: 0.5%.",
        "4. إعلان تمويلي: 2,500 ريال شهرياً.",
        "5. تقرير تحليلات سوق: 5,000 ريال.",

        "سادساً: رسوم المزادات",
        "• باقة أساسية: 2,000 ريال.",
        "• باقة ممتازة: 3,500 ريال.",
        "• ترويج إضافي: ذهبية (2,000 ريال)، بلاتينية (4,000 ريال).",

        "سابعاً: خدمة العرض ثلاثي الأبعاد (3D)",
        "• أقل من 300م: 800 ريال.",
        "• 300-600م: 1,200 ريال.",
        "• عقار تجاري: 1,500 ريال.",
        "• اشتراك شهري: 2,000 ريال (5 عقارات).",
        "• اشتراك ربع سنوي: 5,500 ريال (15 عقاراً).",
        "• اشتراك سنوي: 18,000 ريال (50 عقاراً).",
        "• جولة مباشرة: 500 ريال.",
        "• عمولة إضافية 0.5% عند إتمام صفقة عبر 3D.",

        "ثامناً: سياسة الإلغاء والاسترداد",
        "1. الإعلانات: استرداد 50% خلال 24 ساعة فقط.",
        "2. الاشتراكات: غير قابلة للاسترداد بعد التفعيل.",
        "3. باقات المطورين والمزادات: استرداد كامل خلال 7 أيام إذا لم يتم الاستخدام.",
        "4. رسوم التسجيل: غير قابلة للاسترداد.",
        "5. خدمة 3D: استرداد كامل قبل 7 أيام من بدء التنفيذ.",

        "تاسعاً: أحكام ختامية",
        "1. يحق للمنصة تعديل الرسوم مع إشعار مسبق 30 يوماً.",
        "2. النزاعات تخضع لبند حل النزاعات.",
        "3. جميع الرسوم تشمل ضريبة القيمة المضافة 15%.",
        "4. للاستفسارات يرجى التواصل عبر القنوات الرسمية بالمنصة.",
      ],
    },
    {
      title: "تاسعاً: أحكام ختامية",
      content: [
        "1. تعتبر هذه الشروط ملزمة لجميع الأطراف بمجرد استخدام المنصة.",
        "2. تخضع هذه الشروط لقوانين المملكة العربية السعودية.",
        "3. تختص محاكم المملكة بالنظر في أي نزاع.",
        "4. يحق للمنصة تعديل الشروط وإشعار المستخدمين.",
        "5. دفع العمولات والرسوم يتم عبر بوابة دفع مرخصة، مع إصدار فواتير إلكترونية.",
        "6. تسوية الرسوم: شهرية للوكلاء والمطورين، ربع سنوية للبنوك.",
        "7. عقوبات تأخير الدفع: 5% غرامة شهرية بعد 30 يوم.",
      ],
    },
  ],
  en: [
    {
      title: "First: General Terms and Conditions of the Application",
      content: [
        "1. Introduction and Acceptance",
        "1.1 SNA Real Estate website (hereinafter referred to as the “Application” or “Platform”) provides services for listing, selling, buying, and leasing real estate within the Kingdom of Saudi Arabia.",
        "1.2 By using the Application, you have read these Terms and Conditions and agreed to be bound by them. Usage constitutes full agreement to all terms.",
        "2. Definitions",
        "• Platform/Application: SNA electronic system (Platform, Website, Mobile App, or APIs).",
        "• User: Any natural or legal person creating an account or using the Platform for lawful purposes (Buyer, Tenant, Agent, Developer, Bank, or Financing Entity).",
        "• Agent: A legally licensed real estate broker providing services via the Platform.",
        "• Developer: Any company or entity owning real estate projects offered for sale or lease through the application.",
        "• Bank/Financing Entity: An entity displaying financing products via the Platform.",
        "• Authority: General Authority for Real Estate and other relevant Saudi government entities.",
        "3. Scope of Service",
        "3.1 The platform acts as a licensed technical intermediary for listing properties and connecting parties; it is not a substitute for official legal procedures for title transfers or lease contracts.",
        "3.2 The Platform provides tools for ad management, communication, visit scheduling, and integration with approved real estate financing solutions.",
        "4. Compliance with Regulations and Governance",
        "4.1 The Platform and all parties must comply with all Saudi regulations related to real estate, including licensing, data protection, VAT, e-invoicing, and electronic payment regulations.",
        "5. Account Creation and Verification",
        "5.1 Users must provide accurate and updated data upon registration and bear full responsibility for any misleading information.",
        "5.2 The Platform may request verification documents (National ID, Professional License, Title Deeds, Authorizations) and may suspend accounts temporarily or permanently.",
        "6. Intellectual Property",
        "6.1 All contents, including logos, texts, images, and code, are the exclusive intellectual property of Masar Al-Amjad Company.",
        "7. Prices, Payments, and Invoicing",
        "7.1 The Platform displays estimated prices. VAT and e-invoicing apply according to ZATCA requirements.",
        "8. Data Protection and Privacy",
        "8.1 The Platform collects personal and location data to improve services, adhering to strict data confidentiality requirements.",
        "9. Limitation of Liability",
        "9.1 As a technical intermediary, the Platform is not responsible for the accuracy of property data or agreements made outside the official legal framework.",
        "9.2 The Platform is not liable for indirect or consequential losses.",
        "10. Account Termination and Suspension",
        "10.1 The Platform may suspend or delete accounts for term violations, official requests, or security reasons.",
        "11. Dispute Resolution and Applicable Law",
        "11.1 These terms are governed by the laws of the Kingdom of Saudi Arabia and the jurisdiction of Saudi courts.",
        "11.2 The Arabic language remains the primary reference in case of conflict between texts.",
      ],
    },
    {
      title:
        "Second: Terms and Conditions for Real Estate Agents and Developers",
      content: [
        "This section is for licensed agents using the platform to list properties and communicate with buyers and tenants.",
        "1. Eligibility and Registration",
        "1.1 Agents must be licensed by competent authorities and provide copies of license and commercial registration.",
        "1.2 Verification processes will be conducted to confirm document validity.",
        "2. Listing Requirements",
        "2.1 Accurate info required: description, address, photos, area, deed number, ownership status, and price.",
        "2.2 If the agent doesn't own the deed, a documented authorization must be provided.",
        "2.3 Misleading data or hiding property defects is strictly prohibited.",
        "3. Documentation and Trust Fees",
        "3.1 A 'Verified' tag is added after document verification.",
        "3.2 Unverified ads will display an 'Under Verification' label.",
        "4. Communication and Deals",
        "4.1 Communication must occur within Platform channels.",
        "4.2 Final financial agreements must be documented via legal contracts; the Platform is not a party.",
        "5. Commissions and Fees",
        "5.1 Payment of featured listing fees or marketing services per the price plan.",
        "5.2 Clarification of commission arrangements between the Agent and the Owner.",
        "6. Prohibited Advertisements",
        "6.1 Listing properties that violate regulations is prohibited.",
        "7. Warranties and Indemnity",
        "7.1 The Agent is responsible for incorrect data and agrees to indemnify the Platform.",
        "8. Suspension and Penalties",
        "8.1 The Platform may suspend ads or accounts upon violation.",
        "9. Additional Requirements for Professional Advertisers",
        "9.1 Extra requirements may apply to brokers with a high volume of listings.",
      ],
    },
    {
      title: "Third: Terms and Conditions for Real Estate Developers",
      content: [
        "This section is for developers listing residential/commercial projects, including off-plan projects.",
        "1. Eligibility and Registration",
        "1.1 Provide valid commercial registration, activity license, project documents, and authorized representative data.",
        "1.2 Verification of documents before activating the project page.",
        "2. Project Listing Requirements",
        "2.1 Full project file: prices, payment schedule, unit specs, 3D models/photos.",
        "2.2 Disclosure of pre-sale risks and related terms.",
        "3. Warranties and Delivery",
        "3.1 Specification of expected delivery date, including Force Majeure clauses.",
        "3.2 Clarification of warranty and maintenance policies after handover.",
        "4. Financial Accounts and Payments",
        "4.1 Acceptance of secure payment methods and issuance of e-invoices.",
        "5. Legal Disclosures",
        "5.1 Disclosure of any legal cases or property restrictions.",
        "5.2 Disclosure of any material modifications to the project.",
        "6. Partnership with the Platform",
        "6.1 Signing an agreement defining Platform obligations and commission rates.",
        "7. Suspension and Accountability",
        "7.1 Temporary or permanent project suspension upon proven violations.",
      ],
    },
    {
      title: "Fourth: Terms and Conditions for Banks/Real Estate Financing",
      content: [
        "1. Partnership and Registration",
        "1.1 Signing a partnership agreement before displaying products.",
        "1.2 Providing a valid banking license and contact details.",
        "2. Data Sharing and Customer Privacy",
        "2.1 Sharing data only with explicit user consent.",
        "2.2 The Bank is responsible for data confidentiality and use for financing purposes only.",
        "3. Offers and Information Commitment",
        "3.1 Clear terms: interest rate, duration, fees, and guarantees.",
        "3.2 Prohibition of misleading promotional terms.",
        "4. Verification and Preliminary Approval",
        "4.1 Providing preliminary approval services subject to final verification.",
        "4.2 The Platform is not responsible for the final credit decision.",
        "5. Referral Fees/Profit Model",
        "5.1 Agreement on a commission percentage or fixed fee per lead.",
        "5.2 Tax obligations apply to both parties according to legislation.",
        "6. Compliance Requirements",
        "6.1 Adherence to credit standards and processes.",
        "6.2 The Platform may suspend data transfer if fraud is suspected.",
        "7. App Interface and Technical Integration",
        "7.1 Technical usage terms: security policy, API keys, technical support.",
        "7.2 15-day notice required for any changes.",
        "8. Promotional Ads and Offers",
        "8.1 Clear clarification of fee conditions and offer durations.",
        "9. Responsibility and Warranties",
        "9.1 The Platform is not liable for Bank decisions; the Bank is responsible for product accuracy.",
      ],
    },
    {
      title: "Fifth: Terms and Conditions for Auction Advertisements",
      content: [
        "1. The Platform allows advertising real estate auctions organized by owners, developers, brokers, or banks.",
        "2. The Platform's role is limited to publishing the ad and marketing based on provided info.",
        "3. The organizer is responsible for detail accuracy and legal procedures.",
        "4. The Platform is not responsible for auction results or resulting disputes.",
        "5. Compliance with terms set by the organizing entity.",
        "6. The Platform reserves the right to reject/cancel any violating ad.",
        "7. Ad fees are fixed and non-refundable.",
        "8. Additional packages for featured ads available for extra fees.",
        "9. Complaints must be directed to the organizing entity.",
      ],
    },
    {
      title: "Sixth: Terms and Conditions for 3D View Service",
      content: [
        "1. Service Nature: A technical tool for virtual property viewing.",
        "2. Platform Responsibility: Not liable for differences between the model and physical inspection.",
        "3. Owner/Developer Responsibility: Providing accurate data and bearing responsibility for inaccuracies.",
        "4. Intellectual Property: All models are protected; copying without permission is prohibited.",
        "5. Service Use: For preliminary evaluation only; no legal obligations.",
        "6. Compliance: The Platform updates standards to match Saudi regulations.",
      ],
    },
    {
      title: "Seventh: Privacy Policy",
      content: [
        "1. Introduction: Protecting user privacy and complying with regulations.",
        "2. Data Collected: Registration, usage, property, financing, and location data.",
        "3. Data Use: Improving experience, identity verification, and limited sharing.",
        "4. Data Sharing: With user consent, government entities, or Platform partners.",
        "5. Data Protection: Encryption, local Saudi data centers, and limited staff access.",
        "6. User Rights: Access, correction, deletion of data, and withdrawal of consent.",
        "7. Data Retention: For the period necessary to provide services or as required by law.",
        "8. Amendments: The Platform may modify the policy with user notification.",
        "9. Contact: Via official email for inquiries.",
      ],
    },
    {
      title: "Eighth: Fees and Commissions",
      main: [
        `SNA Real Estate Platform ("the Platform") imposes fees and commissions for the services provided to users ("the Beneficiary") in accordance with the categories and provisions outlined below. All amounts are calculated in Saudi Riyals (SAR) and include Value Added Tax (VAT) where applicable, in accordance with the regulations in force in the Kingdom of Saudi Arabia.`,
      ],
      content: [
        "First: General Provisions",
        "1. All fees and commissions are subject to periodic updates, with users being notified at least 30 days prior to implementation.",
        "2. Payments must be made through the Platform’s approved electronic payment gateways only.",
        "3. The refund policy stated under Section (Eighth) shall apply in case of cancellation or incomplete services.",
        "4. The Platform is not responsible for any additional commissions agreed upon between users outside the Platform.",

        "Second: Account Registration Fees",
        "• Basic account registration is free for all user categories.",
        "• Optional verification service: First month free, second and third months SAR 50 per month, thereafter SAR 99 per month.",

        "Third: Buyers, Sellers, Tenants, and Agents Fees",
        "• Listing the first 3 properties is free, then SAR 40 for each additional property.",
        "• Property listing renewal: SAR 30 per month after the initial 30-day period.",
        "• Premium Membership: SAR 399 monthly or SAR 3,999 annually.",
        "• Featured Ads: 7 days (SAR 80), 15 days (SAR 140), 30 days (SAR 240).",
        "• Transaction commission: 1% of the total transaction value.",

        "Fourth: Developers Fees",
        "1. New project registration: SAR 1,800.",
        "2. First 20 units included, then SAR 15 per additional unit.",
        "3. Marketing Packages: Bronze (SAR 4,000), Silver (SAR 8,000), Gold (SAR 15,000).",
        "4. Sales commission: 0.5% of each unit sold through the Platform.",

        "Fifth: Banks and Financial Institutions Fees",
        "1. Registration fee: SAR 12,000 (one-time).",
        "2. Annual subscription: SAR 22,000.",
        "3. Financing success commission: 0.5% of approved financing amount.",
        "4. Promotional financing ad: SAR 2,500 per month.",
        "5. Quarterly market analytics report: SAR 5,000.",

        "Sixth: Auctions Fees",
        "• Basic package: SAR 2,000.",
        "• Premium package: SAR 3,500.",
        "• Additional promotion: Gold (SAR 2,000), Platinum (SAR 4,000).",

        "Seventh: 3D Property Showcase Service",
        "• Less than 300 sqm: SAR 800.",
        "• 300–600 sqm: SAR 1,200.",
        "• Commercial property: SAR 1,500.",
        "• Monthly subscription: SAR 2,000 (5 properties).",
        "• Quarterly subscription: SAR 5,500 (15 properties).",
        "• Annual subscription: SAR 18,000 (50 properties).",
        "• Live virtual tour (30 minutes): SAR 500.",
        "• Additional 0.5% commission applies if a sale or lease is completed through the 3D service.",

        "Eighth: Cancellation and Refund Policy",
        "1. Regular and featured ads: 50% refund if canceled within 24 hours only.",
        "2. Subscriptions: Non-refundable after activation.",
        "3. Developer and auction packages: Full refund within 7 days if unused.",
        "4. Registration fees: Non-refundable after activation.",
        "5. 3D service: Full refund if canceled at least 7 days before execution.",

        "Ninth: Final Provisions",
        "1. The Platform reserves the right to amend fees with 30 days prior notice.",
        "2. Any disputes shall be subject to the dispute resolution clause.",
        "3. All fees include 15% VAT in accordance with Saudi regulations.",
        "4. For billing inquiries, please contact the Platform through official communication channels.",
      ],
    },
    {
      title: "Ninth: Final Provisions",
      content: [
        "1. These terms are binding upon all parties once the Platform is used.",
        "2. These terms are subject to the laws of the Kingdom of Saudi Arabia.",
        "3. Saudi courts have jurisdiction over any disputes.",
        "4. The Platform may amend terms and notify users.",
        "5. Commission/Fee payments via licensed payment gateways with e-invoicing.",
        "6. Fee Settlement: Monthly for agents/developers, quarterly for banks.",
        "7. Late Payment Penalties: 5% monthly penalty after 30 days.",
      ],
    },
  ],
};

export const tabs = [
  {
    name_ar: "الخدمات الفردية",
    name_en: "Individual Services",
    value: "individual",
  },
  { name_ar: "الاشتراكات", name_en: "Subscriptions", value: "subscriptions" },
];

export const pricingData = {
  individual: [
    {
      title_ar: "مساحة أقل من 300م",
      title_en: "Under 300m²",
      price: "800",
      features_ar: ["تصوير ثلاثي الأبعاد", "جودة عالية", "تسليم سريع"],
      features_en: ["3D Scanning", "High Quality", "Fast Delivery"],
      value: "under_300",
    },
    {
      title_ar: "مساحة 300-600م",
      title_en: "300-600m²",
      price: "1,200",
      features_ar: ["تصوير ثلاثي الأبعاد", "تغطية كاملة للمساحة", "دعم فني"],
      features_en: ["3D Scanning", "Full Coverage", "Technical Support"],
      isHighlight: true,
      value: "300_600",
    },
    {
      title_ar: "عقار تجاري",
      title_en: "Commercial Property",
      price: "1,500",
      features_ar: ["تصوير تجاري احترافي", "إضافة نقاط اهتمام", "رابط خاص"],
      features_en: [
        "Professional Commercial Scan",
        "Custom Hotspots",
        "Direct Link",
      ],
      value: "commercial",
    },
    {
      title_ar: "جولة مباشرة",
      title_en: "Live Tour",
      price: "500",
      features_ar: ["بث مباشر للجولة", "تفاعل لحظي", "تسجيل الجولة"],
      features_en: [
        "Live Streaming",
        "Real-time Interaction",
        "Tour Recording",
      ],
      value: "live_tour",
    },
  ],
  subscriptions: [
    {
      title_ar: "اشتراك شهري",
      title_en: "Monthly Subscription",
      price: "2,000",
      unit_ar: "/ شهر",
      unit_en: "/ month",
      features_ar: ["5 عقارات شهرياً", "تشمل جولة مباشرة", "دعم أولوية"],
      features_en: [
        "5 Properties/Month",
        "Includes Live Tour",
        "Priority Support",
      ],
      value: "monthly",
    },
    {
      title_ar: "اشتراك ربع سنوي",
      title_en: "Quarterly Subscription",
      price: "5,500",
      unit_ar: "/ 3 شهور",
      unit_en: "/ 3 months",
      features_ar: [
        "15 عقاراً",
        "تشمل جولة مباشرة",
        "دعم أولوية",
        "تحديثات مجانية",
      ],
      features_en: [
        "15 Properties",
        "Includes Live Tour",
        "Priority Support",
        "Free Updates",
      ],
      isHighlight: true,
      value: "quarterly",
    },
    {
      title_ar: "اشتراك سنوي",
      title_en: "Annual Subscription",
      price: "18,000",
      unit_ar: "/ سنة",
      unit_en: "/ year",
      features_ar: ["50 عقاراً", "أفضل قيمة", "مدير حساب خاص"],
      features_en: ["50 Properties", "Best Value", "Dedicated Account Manager"],
      value: "annual",
    },
  ],
};

export const propertyTypeLabels: Record<string, { ar: string; en: string }> = {
  apartment: {
    ar: "شقة",
    en: "Apartment",
  },
  villa: {
    ar: "فيلا",
    en: "Villa",
  },
  chalet: {
    ar: "شاليه",
    en: "Chalet",
  },
  commercial: {
    ar: "تجاري",
    en: "Commercial",
  },
  land: {
    ar: "أرض",
    en: "Land",
  },
  office: {
    ar: "مكتب",
    en: "Office",
  },
  shop: {
    ar: "محل",
    en: "Shop",
  },
  warehouse: {
    ar: "مستودع",
    en: "Warehouse",
  },
  house: {
    ar: "منزل",
    en: "House",
  },
  studio: {
    ar: "استوديو",
    en: "Studio",
  },

  // NEW
  duplex: { ar: "دوبلكس", en: "Duplex" },
  penthouse: { ar: "بنتهاوس", en: "Penthouse" },
  farm: { ar: "مزرعة", en: "Farm" },
  camp: { ar: "مخيم", en: "Camp" },
  floor: { ar: "دور", en: "Floor" },
  building: { ar: "عمارة", en: "Building" },
  room: { ar: "غرفة", en: "Room" },
  residential_land: { ar: "أرض سكنية", en: "Residential Land" },
  commercial_land: { ar: "أرض تجارية", en: "Commercial Land" },
  showroom: { ar: "معرض", en: "Showroom" },
  hotel_apartment: { ar: "شقة فندقية", en: "Hotel Apartment" },
  rest_house: { ar: "استراحة", en: "Rest House" },
};

export const roles = [
  {
    labelEn: "Developer",
    labelAr: "مطور عقاري",
    value: "developer",
  },
  {
    labelEn: "Agent",
    labelAr: "وكيل عقاري",
    value: "agent",
  },
  {
    labelEn: "Markter",
    labelAr: "مسوق عقاري",
    value: "markter",
  },
  {
    labelEn: "Bank",
    labelAr: "بنك/جهة تمويل",
    value: "bank",
  },
];
